import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/system";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ASSETS } from "../../../utils/config";
import { colors } from "../../../utils";
import TextView from "../../TextView";
import FoldersThreeDotMenu from "../FoldersThreeDotMenu";

const FolderTileContainer = styled("div")(({ isSelected, hideBackgroundColor }) => ({
  padding: "10px 8px",
  borderRadius: 4,
  border: `1px solid ${colors.lightBorder}`,
  display: "flex",
  justifyContent: "space-between",
  boxSizing: "border-box",
  backgroundColor: isSelected ? colors.Highlight : (hideBackgroundColor ? 'white' : colors.NeutralBackground),
  alignItems: "center",
  cursor: "pointer",
  userSelect: "none",
}));

const FolderTile = ({ 
  id, 
  name, 
  visibility, 
  galleryVisibility, 
  isSelected, 
  onDoubleClick = () => {}, 
  onSingleClick = () => {},
  onSettingsClick = () => {},
  onMoveClick = () => {},
  onVisibilityChange = () => {},
  onDeleteClick = () => {},
  hideThreeDotIcon = false,
  showArrowIcon = false,
  hideBackgroundColor = false
}) => {
  const getFolderIcon = () => {
    return visibility === 1 ? ASSETS.segmentEditor.PublicFolder : ASSETS.segmentEditor.PrivateFolder;
  };

  const getTitle = () => {
    const displayName = name || "Unnamed Folder";
    return displayName.length > 30 ? `${displayName.substring(0, 30)}...` : displayName;
  };

  return (
    <FolderTileContainer 
      onDoubleClick={onDoubleClick} 
      onClick={onSingleClick} 
      isSelected={isSelected}
      hideBackgroundColor={hideBackgroundColor}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={getFolderIcon()} width={24} height={24} alt="Folder Icon" />
        <TextView variant="text" style={{ fontWeight: 700, paddingLeft: 10 }}>{getTitle()}</TextView>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {galleryVisibility && (
          <Tooltip title="Contents hidden from Wheel tab">
            <img src={ASSETS.segmentEditor.Incognito} width={18} height={18} alt="Incognito" />
          </Tooltip>
        )}
        {!hideThreeDotIcon && (
          <FoldersThreeDotMenu
            folder={{ id, name, visibility, gallery_visibility: galleryVisibility }}
            onSettingsClick={() => onSettingsClick({ id, name, visibility, gallery_visibility: galleryVisibility })}
            onMoveClick={onMoveClick}
            onVisibilityChange={onVisibilityChange}
            onDeleteClick={onDeleteClick}
          />
        )}
        {showArrowIcon && (
          <ChevronRightIcon sx={{ color: colors.primary, ml: 1 }} />
        )}
      </div>
    </FolderTileContainer>
  );
};

FolderTile.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  visibility: PropTypes.number.isRequired,
  galleryVisibility: PropTypes.bool,
  isSelected: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onSingleClick: PropTypes.func,
  onSettingsClick: PropTypes.func,
  onMoveClick: PropTypes.func,
  onVisibilityChange: PropTypes.func,
  onDeleteClick: PropTypes.func,
  hideThreeDotIcon: PropTypes.bool,
  showArrowIcon: PropTypes.bool,
  hideBackgroundColor: PropTypes.bool
};

export default FolderTile;